import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { distinctUntilChanged, filter, switchMap } from 'rxjs'

import { OnboardPersistState, persistence, persistStateFactory } from '../state/persistence'

const persistPractitionerState$ = persistStateFactory(persistence.practitionerApiUrl)

const [practitionerPersistedStateChange$, setPractitionerPersistedState] =
  createSignal<OnboardPersistState>()

export { setPractitionerPersistedState }

export const [useOnboardPractitionerPersist, persistedPractitionerState$] = bind(
  practitionerPersistedStateChange$.pipe(
    filter(({ state }) => state !== 'createAccountPersist'),
    distinctUntilChanged((prev, next) => prev.state === next.state),
    switchMap(persistPractitionerState$),
  ),
  {
    loading: false,
    result: null,
    called: false,
  },
)
